enum TrialSide {
  PLAINTIFF = 'PLAINTIFF',
  DEFENDANT = 'DEFENDANT',
  OFFICIAL = 'OFFICIAL',
}

export default TrialSide;
